import { SUMMARY } from './action';

const INITIAL_STATE = {
    loading: false,
    error: '',
    isLoggedIn: false,
    summary: []
};


const summary = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SUMMARY.SUMMARY_START:
            return { ...state, loading: true, error: '', isLoggedIn: false }
        case SUMMARY.SUMMARY_SUCCESS:
            return { ...state, loading: false, summary: action.payload, isLoggedIn: true }
        case SUMMARY.SUMMARY_ERROR:
            return { ...state, loading: false, error: action.payload, isLoggedIn: false }

        default:
            return state;
    }
}

export default summary;


